import React, { useState, useEffect, useCallback } from "react";
import { Col, Row, Image } from "react-bootstrap";
import { ChartsComponent } from "../../../reusableComponent";

// charts constants
import { FIRST_BAR_CHART_HELPER } from "./barchart.first";
import { SEC_BAR_CHART_HELPER } from "./barchart.second";
import { THIRD_BAR_CHART_HELPER } from "./barchart.third";
import { FOURTH_BAR_CHART_HELPER } from "./barchart.fourth";
import { FIFTH_BAR_CHART_HELPER } from "./barchart.fifth";
import { SIXTH_BAR_CHART_HELPER } from "./barchart.sixth";

// actions
import {
  getOpenProjectSectorDistributionAction,
  getResolvedProjectSectorDistributionAction,
  getProjectSectorDistributionByCreatedDateAction
} from "../../../../actions/reports.action";

// helper
import { Date_Helper } from "../chartHelper";

const ThirdPage = React.memo(function ThirdPage({
  displayOnDashboard = false
}) {
  const [firstBarChart, setFirstBarChart] = useState({
    isLoading: false,
    data: []
  });
  const [secBarChart, setSecBarChart] = useState({
    isLoading: false,
    data: []
  });
  const [thirdBarChart, setThirdBarChart] = useState({
    isLoading: false,
    data: []
  });

  const from = Date.parse(new Date(2013, 0, 1)),
    to = Date.parse(new Date());

  useEffect(() => {
    getOpenProjectSectorDistributionApisData();
    getResolvedProjectSectorDistributionApisData();
    getProjectSectorDistributionByCreatedDateApiData();
  }, []);

  const getOpenProjectSectorDistributionApisData = async () => {
    // loading started
    setFirstBarChart({ isLoading: true, data: [] });
    // get data
    const resp = await getOpenProjectSectorDistributionAction(undefined, {
      from,
      to
    });
    // loading completed
    setFirstBarChart({
      isLoading: false,
      firstChartData: FIRST_BAR_CHART_HELPER(resp.data),
      secChartData: SEC_BAR_CHART_HELPER(resp.data)
    });
  };

  const getResolvedProjectSectorDistributionApisData = async () => {
    // loading started
    setSecBarChart({ isLoading: true, data: [] });
    // get data
    const resp = await getResolvedProjectSectorDistributionAction(undefined, {
      from,
      to
    });
    // loading completed
    setSecBarChart({
      isLoading: false,
      firstChartData: THIRD_BAR_CHART_HELPER(resp.data),
      secChartData: FOURTH_BAR_CHART_HELPER(resp.data)
    });
  };

  //
  const getProjectSectorDistributionByCreatedDateApiData = async () => {
    // loading started
    setThirdBarChart({ isLoading: true, data: [] });
    // get data
    const resp = await getProjectSectorDistributionByCreatedDateAction(
      undefined,
      { from, to }
    );
    // loading completed
    setThirdBarChart({
      isLoading: false,
      firstChartData: FIFTH_BAR_CHART_HELPER(resp.data),
      secChartData: SIXTH_BAR_CHART_HELPER(resp.data)
    });
  };

  return (
    <>
      {/* PDF First Section Start */}
      <Col lg={12} className={"charts-sections first-section"}>
        <Row>
          <Col id="first-section-header">UNDER CONSIDERATION PROJECTS</Col>
        </Row>
        <Row id="first-section-title" />
        <Row>
          <Col id="first-section-title-component">
            SECTOR DISTRIBUTION : 263 UNDER CONSIDERATION (OPEN) PROJECTS
          </Col>
        </Row>

        <Row className="first-section-chart">
          <Col lg={6}>
            <ChartsComponent
              isLoading={firstBarChart.isLoading}
              chartConfig={firstBarChart.firstChartData}
            />
          </Col>
          <Col lg={6}>
            <ChartsComponent
              isLoading={firstBarChart.isLoading}
              chartConfig={firstBarChart.secChartData}
            />
          </Col>
          <section className="col" id="third-page-first-section-labels" />
        </Row>
        <Row>
          <Col>
            <section id="third-page-first-section-subtitle-1" />
          </Col>
        </Row>
      </Col>

      {/* second section  */}
      {displayOnDashboard ? null : (
        <Col lg={12} className={"charts-sections first-section"}>
          <Row>
            <Col id="second-section-header">RESOLVED PROJECTS</Col>
          </Row>
          <Row id="second-section-title">
            DYNAMICALLY REPLACED FROM ITS CHART
          </Row>
          <Row>
            <Col id="second-section-title-component">
              DYNAMICALLY REPLACED FROM ITS CHART
            </Col>
          </Row>
          <Row className="second-section-chart">
            <Col lg={6}>
              <ChartsComponent
                isLoading={secBarChart.isLoading}
                chartConfig={secBarChart.firstChartData}
              />
            </Col>
            <Col lg={6}>
              <ChartsComponent
                isLoading={secBarChart.isLoading}
                chartConfig={secBarChart.secChartData}
              />
            </Col>
            <section className="col" id="third-page-second-section-labels" />
          </Row>
          <Row>
            <Col>
              <section id="third-page-second-section-subtitle-1" />
            </Col>
          </Row>
        </Col>
      )}

      {/* third section  */}
      <Col lg={12} className={"charts-sections first-section"}>
        <Row>
          <Col id="third-section-header">TOTAL PROJECTS</Col>
        </Row>
        <Row id="third-section-title">DYNAMICALLY REPLACED FROM ITS CHART</Row>
        <Row>
          <Col id="third-section-title-component">
            DYNAMICALLY REPLACED FROM ITS CHART
          </Col>
        </Row>
        <Row className="third-section-chart">
          <Col lg={6}>
            <ChartsComponent
              isLoading={thirdBarChart.isLoading}
              chartConfig={thirdBarChart.firstChartData}
            />
          </Col>
          <Col lg={6}>
            <ChartsComponent
              isLoading={thirdBarChart.isLoading}
              chartConfig={thirdBarChart.secChartData}
            />
          </Col>
          <section className="col" id="third-page-third-section-labels" />
        </Row>
        <Row>
          <Col>
            <section id="third-page-third-section-subtitle-1" />
          </Col>
        </Row>
      </Col>
    </>
  );
});

export { ThirdPage };
